<template>
    <ResourceCard
        v-if="guide.data"
        :document-type="guide.type"
        :image="guide.data.thumbnail"
        :title="guide.data.title"
        :excerpt="guide.data.excerpt"
        :to="resolvePrismicLink(guide)"
        :resource-categories="(guide.data?.resourceCategories as {resourceCategory: ResourceCategoryDocument}[]) ?? undefined"
        :category="guide.data.category"
        :date="releaseDate"
        :base-data-testid="baseDataTestid"
    />
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {FilledContentRelationshipField} from '@prismicio/types';
    import type {GuideDocument, GuideDocumentData, ResourceCategoryDocument} from '@prismicio-types';
    import {useFormat, useLinkHelper} from '#imports';
    import ResourceCard from '~/components/ResourceCard.vue';
    import {createContentHelpers} from '~/composables/contentHelpers';

    const props = defineProps<{
        guide: GuideDocument | FilledContentRelationshipField<'guide', string, GuideDocumentData>;
    }>();

    const {resolvePrismicLink} = useLinkHelper();
    const {getPublicationDate} = createContentHelpers();
    const {formatDate} = useFormat();
    const releaseDate = formatDate(getPublicationDate(props.guide));

    const baseDataTestid = computed(() => props.guide.uid ?? props.guide.id);
</script>
